<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em">John Cranberry was born and raised in Sydney, Australia. Although he did not excel in school due to undiagnosed dyslexia, he did excel in subjects like photography and art that required his creativity and imagination to shine.</p><br/>
<p style="text-indent:0em">His creative writing began as early as high school, writing adventurous letters and passing them onto his dear friend, Kat, between classes for her amusement.</p><br/>
<p style="text-indent:0em">Later in life, John decided to put pen to paper for the first time in over a decade, determined to write his first novel. He had an unfulfilled passion to express himself through his creative writing once again, but this time, he aimed to reach a greater audience. This is when Audrey was conceived.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7e11e45b